module.exports = __webpack_public_path__ + "2e257b33d0e59e1f208d0801b56e97c1.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/tiers/wing-0.png
// module id = 3010
// module chunks = 0